module.exports = __webpack_public_path__ + "img/stock4.84333eab.png";